export default {
  details: {
    title: "Hady Zeitouny",
    tagLine: "Software Developer",
    description: "Personal portfolio of Hady Zeitouny",
    url: "",
  },
  assets: {
    avatar: "/images/common/avatar.jpg",
    favicon: "/images/common/favicon.png",
  },
  socialLinks: {
    twitter: "@HZ_2520",
  },
};
